import React, { useState, useEffect } from "react";
import axios from "axios";
import API_ENDPOINT from "../wm.api.service";
import "./login.css";
import Wmbutton from "../ui-components/wm-button/Wm.button";
import WmModals from "../modals/Wm.Modals";
import Wminput from "../ui-components/wm-form-components/input/Wm.input";
import Cookies from "universal-cookie";
import { useHistory } from "react-router-dom";
import { encode, decode } from "base-64";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { Container, Row, Col } from "react-bootstrap";
import google from "../assets/images/google-icon.svg";
import logo from "../assets/images/logo2.svg";
import CircularProgress from "@material-ui/core/CircularProgress";
import eye from "../assets/images/eye.png";
import hide from "../assets/images/noteye.png";
import ReCAPTCHA from "react-google-recaptcha";
import { useGoogleLogin } from "react-google-login";
import Spinner from "../Components/spinner/Spinner";
import { authAction } from "./authActions";
import {
  WM_ENVIRONMENT,
  GOOGLE_CLIENT_ID,
  GOOGLE_RECAPTCHA_SITE_KEY,
  LOGO_PATH,
  PROJECT_NAME,
} from "../config";
const cookies = new Cookies();

function Login() {
  var token = cookies.get("wmtoken");
  var userType = cookies.get("wmusers");
  const history = useHistory();
  const [emailOrPasswordMissing, setEmailOrPasswordMissing] = useState(false);
  const [emailOrPasswordWrong, setEmailOrPasswordWrong] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isGettingLogin, setIsGettingLogin] = useState(false);
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  localStorage.setItem("wm_actionURL", queryString);
  const service = urlParams.get("service");
  const internalSlug = urlParams.get("rdTo");
  const [captaToken, setCaptaToken] = useState("");
  const [errorMes, setErrorMes] = useState("");
  function onChange(value) {
    setCaptaToken(value);
    setErrorMes("");
  }
  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }
  const [isUserDeactiveModal, setUserDeactiveModal] = useState(false);
  const [isPendingApprovalModal, setIsPendingApprovalModal] = useState(false);
  // console.log("v",service)
  const login = (e) => {
    if (captaToken) {
    setIsGettingLogin(true);
    e.preventDefault();
    var fd = new FormData();
    fd.append("email", email);
    fd.append("password", password);
    axios({
      method: "POST",
      url: `${API_ENDPOINT.apiURL}Authentication/loginEmail`,
      data: fd,
    })
      .then((response) => {
        if (response.data.message === "Login Success") {
          var encodeToken = encode(response.data.token);
          cookies.set("wmtoken", encodeToken, {
            domain: ".spiralbound.in",
          });
          if (response.data.isInstitute === true) {
            cookies.set("wmusers", encode("institue"), {
              domain: ".spiralbound.in",
            });
            WM_ENVIRONMENT === "development" &&
              cookies.set("wmusers", encode("institue"), { path: "/" });
          } else {
            cookies.set("wmusers", encode("members"), {
              domain: ".spiralbound.in",
            });
            WM_ENVIRONMENT === "development" &&
              cookies.set("wmusers", encode("members"), { path: "/" });
          }
          WM_ENVIRONMENT === "development" &&
            cookies.set("wmtoken", encodeToken, { path: "/" });
          if (service === null) {
            if (response.data.isInstitute === true) {
              window.location.assign("/i/institute");
            } else {
              window.location.assign("/user");
            }
          } else {
            if (service === null) {
              window.location.assign("/user");
            } else {
              if (
                decode(service) !== "forms" &&
                !decode(service) !== "main" &&
                !decode(service) !== "landingpage"
              ) {
                authAction(encodeToken, service);
              } else if (
                decode(service) === "blogs/create-blogs" ||
                decode(service) === "questions/create-question"
              ) {
                authAction(encodeToken, service);
              } else {
                authAction(encodeToken);
              }
            }
          }
        }
      })
      .catch((err) => {
        setIsGettingLogin(false);
        if (err.response.data.message === "Payload Missing") {
          setEmailOrPasswordMissing(true);
          setEmailOrPasswordWrong(false);
        }
        if (err.response.data.message === "Incorrect Creds") {
          setEmailOrPasswordWrong(true);
          setEmailOrPasswordMissing(false);
        }
        if (err.response.data.message === "User Deactivated") {
          setUserDeactiveModal(true);
        }
        if (
          err.response.data.message ===
          "Your request is still pending for approval"
        ) {
          setIsPendingApprovalModal(true);
        }
      });
    } else {
    setErrorMes("Please Solve The reCaptcha");
    }
  };
  const [showPassword, setShowPassword] = useState(false);
  const userPage = () => {
    if (service === null) {
      if (userType) {
        if (decode(userType) === "members") {
          history.replace("/user");
        } else {
          history.replace("/i/institute");
        }
      } else {
        history.replace("/user");
      }
    }
  };
  const successGoogleLogin = (token, id, email, firstname, lastname, photo) => {
    var fd = new FormData();
    fd.append("idToken", token);
    fd.append("id", id);
    fd.append("email", email);
    fd.append("photo", photo);
    fd.append("first_name", firstname);
    fd.append("last_name", lastname);
    fd.append("platform", "web");
    axios({
      method: "POST",
      url: `${API_ENDPOINT.apiURL}Authentication/loginGoogle`,
      data: fd,
    })
      .then((response) => {
        if (
          response.data.message === "Registration Success" ||
          response.data.message === "Login Success"
        ) {
          var encodeToken = encode(response.data.token);
          cookies.set("wmtoken", encodeToken, { domain: ".spiralbound.in" });
          if (response.data.isInstitute === true) {
            cookies.set("wmusers", encode("institue"), {
              domain: ".spiralbound.in",
            });
            WM_ENVIRONMENT === "development" &&
              cookies.set("wmusers", encode("institue"), { path: "/" });
          } else {
            cookies.set("wmusers", encode("members"), {
              domain: ".spiralbound.in",
            });
            WM_ENVIRONMENT === "development" &&
              cookies.set("wmusers", encode("members"), { path: "/" });
          }
          WM_ENVIRONMENT === "development" &&
            cookies.set("wmtoken", encodeToken, { path: "/" });
          if (service === null) {
            window.location.assign("/user");
          } else {
            if (
              decode(service) !== "forms" &&
              !decode(service) !== "main" &&
              !decode(service) !== "landingpage"
            ) {
              authAction(encodeToken, service);
            } else if (
              decode(service) === "blogs/create-blogs" ||
              decode(service) === "questions/create-question"
            ) {
              authAction(encodeToken, service);
            } else {
              authAction(encodeToken);
            }
          }
          setIsGettingLogin(false);
        }
      })
      .catch((err) => {
        setIsGettingLogin(false);
        console.log(err);
        if (err.response.data.message === "User Deactivated") {
          setUserDeactiveModal(true);
        }
      });
  };
  const clientId = GOOGLE_CLIENT_ID;
  const [isMailSentMessage, setIsMailSentMessage] = useState(false);
  const [isReactivating, setIsReactivating] = useState(false);
  const reactiveAccount = () => {
    setIsReactivating(true);
    var fd = new FormData();
    fd.append("email", email);
    axios({
      method: "POST",
      url: `${API_ENDPOINT.apiURL}Authentication/reactivateUser`,
      data: fd,
    })
      .then((response) => {
        setUserDeactiveModal(false);
        setIsMailSentMessage(true);
        setIsReactivating(false);
        setEmail("");
        setPassword("");
      })
      .catch((err) => {
        setIsGettingLogin(false);
        setIsReactivating(false);
      });
  };
  const onFailure = (res) => {
    setIsGettingLogin(false);
    if (res.details === "Cookies are not enabled in current environment.") {
      alert(
        'Cookies are not enabled, Please go to settings and enable "Allow all cookies"'
      );
    }
  };
  const onSuccess = (res) => {
    setIsGettingLogin(true);
    successGoogleLogin(
      res.tokenId,
      res.googleId,
      res.profileObj.email,
      res.profileObj.givenName,
      res.profileObj.familyName,
      res.profileObj.imageUrl
    );
  };
  const { signIn } = useGoogleLogin({
    onSuccess,
    onFailure,
    clientId,
    cookiePolicy: "single_host_origin",
  });
  useEffect(() => {
    if (token) {
      userPage();
    }
  }, []);
  return (
    <>
      <>
        {isGettingLogin && (
          <div className=" absolute w-full h-full flex items-center justify-center z-40 backdrop-filter backdrop-blur-sm">
            <Spinner width="50" height="50" />
          </div>
        )}
        <div className="loginBg loginBG_img">
          <div>
            <div className="login py-5">
              <div className="flex justify-center mb-4">
                <img src={LOGO_PATH} alt={`${PROJECT_NAME} logo`} className="w-24" />
              </div>
              <div className="login_container shadow">
                <form>
                  <Container>
                    <Row>
                      <Col md={12}>
                        <span className="mb-3 font-semibold block text-4xl login-fs">
                          Login
                        </span>
                        <p className="caption_sign mb-4">
                          Stay updated on your professional world
                        </p>
                      </Col>
                      <Col md={12}>
                        <div className=" flex flex-col mb-4">
                          <label htmlFor="First name" className="text-sm">
                            Email
                          </label>
                          <Wminput
                            type="email"
                            name="email_phone"
                            autoComplete="off"
                            required
                            onChange={(e) => setEmail(e.target.value)}
                          />
                        </div>
                      </Col>
                      <Col md={12}>
                        <div className="wm-form-group flex flex-col mb-3 relative">
                          <label htmlFor="First name" className="text-sm">
                            {" "}
                            Password
                          </label>
                          <div className="flex border-b border-gray-300 border-solid">
                            <Wminput
                              type={`${showPassword ? "text" : "password"}`}
                              name="password_login"
                              autoComplete="off"
                              className="border-0 flex-1"
                              onChange={(e) => setPassword(e.target.value)}
                            />
                            <img
                              src={showPassword ? eye : hide}
                              alt="eye"
                              className="w-7 cursor-pointer"
                              style={{ filter: "opacity(0.5)" }}
                              onClick={() => setShowPassword(!showPassword)}
                            />
                          </div>
                        </div>
                      </Col>
                      <Col md={12}>
                        <div className="text-center">
                          {emailOrPasswordWrong && (
                            <span className="text-red-600 text-xs">
                              Please check your email or password
                            </span>
                          )}
                          {emailOrPasswordMissing && (
                            <span className="text-red-600 text-xs">
                              Missing email or password
                            </span>
                          )}
                          {errorMes && (
                            <span className="text-red-600 text-xs">
                              {errorMes}
                            </span>
                          )}
                        </div>
                      </Col>
                      <Col md={12}>
                        <div className="text-center w-full flex items-center justify-center">
                          <ReCAPTCHA
                            sitekey={GOOGLE_RECAPTCHA_SITE_KEY}
                            onChange={onChange}
                          />
                        </div>
                      </Col>
                      <Col md={12}>
                        <div>
                          <a
                            href={`/forgotpassword${localStorage.getItem(
                              "wm_actionURL"
                            )}`}
                            className="mb-4 inline-block fs-13"
                          >
                            Forgot password?
                          </a>
                        </div>
                      </Col>
                      <Col md={12}>
                        <div className="flex mb-3">
                          <Wmbutton
                            className="h-10 login-btn"
                            label={`${isGettingLogin ? "Loading..." : "Login"}`}
                            type="button"
                            color="primary"
                            onClick={(e) => login(e)}
                            disable={isGettingLogin}
                          />
                        </div>
                      </Col>
                      <Col md={12}>
                        <div className="divider-wrapper text-center">
                          <p className="divider relative">or</p>
                        </div>
                      </Col>
                      <Col md={12}>
                        <div className="flex mb-4">
                          <Wmbutton
                            className="h-10 login-btn flex justify-center items-center"
                            // label="Login with Google"
                            label={
                              isGettingLogin ? (
                                <CircularProgress className="loader_size_xsm" />
                              ) : (
                                "Login with Google"
                              )
                            }
                            type="submit"
                            bordered
                            color="primary"
                            onClick={signIn}
                          >
                            {isGettingLogin ? (
                              ""
                            ) : (
                              <img
                                src={google}
                                alt="google"
                                className="w-4 mr-2 google_ico"
                              />
                            )}
                          </Wmbutton>
                        </div>
                      </Col>
                      <Col md={12}>
                        <div className="already_in_out">
                          <p className="mr-2 fs-13">New to SpiralBound?</p>
                          <a
                            href={`/signup${localStorage.getItem(
                              "wm_actionURL"
                            )}`}
                            className="fs-13 underline"
                          >
                            Join Now
                          </a>
                        </div>
                      </Col>
                    </Row>
                  </Container>
                </form>
              </div>
            </div>
          </div>
        </div>
      </>
      <WmModals
        show={isUserDeactiveModal}
        onHide={() => setUserDeactiveModal(false)}
        size="md"
        className=""
      >
        <div className="container-fluid relative">
          <div className="row">
            <div className="col-md-12 py-3">
              <div className="wm-form-group flex flex-col mb-4 text-center">
                <label
                  htmlFor="First name"
                  className="text-base manpro font-semibold"
                >
                  Do you wish to reactivate you account ?
                </label>
              </div>
              <div className="text-center">
                <Wmbutton
                  label="Yes"
                  onClick={() => reactiveAccount()}
                  className="rounded w-20 mr-3"
                  type="button"
                  color="primary"
                />
                <Wmbutton
                  label="No"
                  onClick={() => setUserDeactiveModal(false)}
                  className="rounded w-20"
                  type="button"
                  color="primary"
                />
              </div>
            </div>
          </div>
        </div>
        {isReactivating && (
          <div
            className="absolute flex items-center justify-center w-full h-full"
            style={{ backgroundColor: "#ffffff96" }}
          >
            <Spinner width={35} height={35} />
          </div>
        )}
      </WmModals>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={isMailSentMessage}
        autoHideDuration={6000}
        onClose={() => setIsMailSentMessage(false)}
        className="toastSuccess"
      >
        <Alert onClose={() => setIsMailSentMessage(false)}>
          Your account activation link has been sent to your email 👍
        </Alert>
      </Snackbar>

      {/* Pending Approval Modal */}
      <WmModals
        show={isPendingApprovalModal}
        onHide={() => setIsPendingApprovalModal(false)}
        size="md"
        className=""
      >
        <div className="container-fluid relative">
          <div className="row">
            <div className="col-md-12 py-4">
              <div className="text-center mb-4">
                <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-yellow-100 mb-3">
                  <svg
                    className="h-10 w-10 text-yellow-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    ></path>
                  </svg>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  Account Pending Approval
                </h3>
                <p className="text-gray-600 mb-4">
                  Your registration request is still pending for approval by our
                  admin team.
                </p>
                <div className="bg-blue-50 border-l-4 border-blue-500 p-3 mb-4 text-left">
                  <p className="text-sm text-blue-700">
                    <strong>Note:</strong> We will notify you via email once
                    your account has been verified and approved. This usually
                    takes 24-48 hours.
                  </p>
                </div>
              </div>
              <div className="text-center">
                <Wmbutton
                  label="OK"
                  onClick={() => setIsPendingApprovalModal(false)}
                  className="rounded px-6"
                  type="button"
                  color="primary"
                />
              </div>
            </div>
          </div>
        </div>
      </WmModals>
    </>
  );
}

export default Login;
